module.exports = __webpack_public_path__ + "img/fly-active.d409e68b.svg";